import React, { Component } from 'react';
import {
  Button,
  Form,
  Label,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import ReactSelect from 'react-select';
import { components } from 'react-select';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import '../SideBarContainer.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import { checkForMultilineText } from '../../../utilities/HelperFunctions/HelperFunctions';
import { Icons } from '../../../utilities';

class AddTextTemplate extends Component {
  getTextAlignmentLabel = textAlign => {
    if (textAlign === 'start') {
      return string.ALIGN_LEFT_KEY;
    }
    if (textAlign === 'middle') {
      return string.TEXT_ANCHOR_MIDDLE;
    }
    if (textAlign === 'end') {
      return string.ALIGN_RIGHT_KEY;
    }
    return '';
  };

  getMatchedColorIndex = (colorArray, inColor) => {
    let activeColor = inColor;
    let matchedIndex = 0;
    colorArray.forEach((iColor, index) => {
      let color = iColor;
      if (color.substr(0, 1) == '#') color = color.substr(1);
      if (activeColor.substr(0, 1) == '#') activeColor = activeColor.substr(1);
      if (color === activeColor) {
        matchedIndex = index;
      }
    });
    return matchedIndex;
  };

  render() {
    const {
      activeTab,
      addText,
      defaultColors,
      documentColors,
      activeObject,
      textFonts,
      dispatchers
    } = this.props;
    if (activeTab === Constants.TEXT_ELEMENT_TYPE) {
      // Text
      let textPlaceholder = '';
      if (addText.customText) {
        textPlaceholder = addText.customText;
      }

      // Text Color
      const textColorIndex = this.getMatchedColorIndex(
        defaultColors,
        addText.textColor
      );

      // Document color
      const documentColorIndex = this.getMatchedColorIndex(
        documentColors,
        addText.textColor
      );

      // Shadow color
      const textShadowColorIndex = this.getMatchedColorIndex(
        documentColors,
        addText.shadowColor
      );

      // Submit button

      const submitButtonString =
        activeObject &&
        Object.prototype.hasOwnProperty.call(activeObject, 'placing') &&
        activeObject.placing.placeableType === Constants.TEXT_ELEMENT_TYPE
          ? string.UPDATE_TEXT_KEY
          : string.ADD_TEXT_KEY;

      const Option = props => {
        const { innerProps, innerRef } = props;
        return (
          <div ref={innerRef} {...innerProps} style={{ padding: '2px 5px' }}>
            <img alt={props.data.name} src={props.data.thumbnail_path} />
          </div>
        );
      };
      const SingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
          <span className='selected-font'>{props.data.name}</span>
        </components.SingleValue>
      );

      const IndicatorSeparator = ({ innerProps }) => (
        <span
          style={{
            alignSelf: 'stretch',
            backgroundColor: 'rgb(110, 111, 113)',
            marginBottom: 0,
            marginTop: 0,
            width: 2
          }}
          {...innerProps}
        />
      );

      return (
        <>
          <div className='d-flex flex-column' style={{ height: '106%' }}>
            <div className='flex-grow-1 content-box'>
              <div className='theme-wrapper theme-wrapper-scroll-bar'>
                <Form
                  id='textPane'
                  className='text-left mb-5'
                  onSubmit={dispatchers.submitAddText}
                >
                  <Input
                    type='textarea'
                    name='customText'
                    id='customText'
                    placeholder={string.PLACEHOLDER_ENTER_TEXT_KEY}
                    value={textPlaceholder}
                    onChange={dispatchers.setCustomText}
                  />

                  {/* Font Family */}
                  <ReactSelect
                    id='react-select-font-family'
                    value={dispatchers.getSelectedFont(addText.fontId)}
                    options={textFonts}
                    onChange={dispatchers.setFontFamily}
                    components={{ Option, SingleValue, IndicatorSeparator }}
                    styles={{
                      control: base => ({
                        ...base,
                        '&:hover': { borderColor: 'gray' },
                        border: '1px solid rgb(128, 128, 128)',
                        borderRadius: '0px',
                        boxShadow: 'none',
                        background: 'none',
                        cursor: 'pointer'
                      })
                    }}
                  />

                  {/* Font Path */}
                  <div id='fontPath' className='d-flex justify-content-between'>
                    {addText.fontPath.map(font => (
                      <Label check key={font.name}>
                        <Input
                          type='radio'
                          name='fontPath'
                          value={font.name}
                          style={{ width: '25%' }}
                          defaultChecked={font.active}
                          onClick={dispatchers.setFontPath}
                        />
                        <img
                          alt={font.name}
                          style={{ width: '100%' }}
                          src={
                            font.active ? font.selectedIconPath : font.iconPath
                          }
                        />
                      </Label>
                    ))}
                  </div>

                  {/* Document colors */}
                  <div className='text-white '>
                    <div id='textPane'>
                      <span
                        className='d-flex'
                        style={{
                          fontSize: '14px',
                          fontFamily: 'HPSimplifiedLight, Arial, sans-serif'
                        }}
                      >
                        {string.DOCUMENT_COLORS}
                      </span>
                      <div id='textColors' className='text-left pt-3 mb-0 '>
                        {documentColors.map((color, index) => (
                          <Label check key={color}>
                            <Input
                              type='radio'
                              name='documentTextColors'
                              value={color}
                              defaultChecked={index === documentColorIndex}
                              onChange={dispatchers.setTextColor}
                            />

                            <div
                              className='colorBox'
                              style={{ background: color }}
                            />
                          </Label>
                        ))}
                        <Label check key='plus'>
                          <Input
                            type='radio'
                            onClick={e => {
                              e.stopPropagation();
                              dispatchers.documentColorPickerHandler(
                                Constants.TEXT_COLOR
                              );
                            }}
                          />
                          <div className='colorBox plus-image' />
                        </Label>
                      </div>
                    </div>
                  </div>
                  <hr />

                  {/* Text Colors */}
                  <div id='textColors'>
                    {defaultColors.map((color, index) => (
                      <Label check key={color}>
                        <Input
                          type='radio'
                          name='textColors'
                          value={color}
                          defaultChecked={index === textColorIndex}
                          onChange={dispatchers.setTextColor}
                        />
                        <div
                          className='colorBox'
                          style={{ background: color }}
                        />
                      </Label>
                    ))}
                  </div>

                  {/* shadowColor */}
                  <UncontrolledDropdown style={{ width: '154px' }}>
                    <DropdownToggle tag='div'>
                      <ReactSelect
                        id='react-select-shadow-dropdown'
                        components={{ Option, SingleValue, IndicatorSeparator }}
                        placeholder={
                          addText.shadowText !== ''
                            ? string.NO_SHADOW_KEY
                            : addText.shadowText
                        }
                        isSearchable={false}
                        isDisabled
                        styles={{
                          control: base => ({
                            ...base,
                            '&:hover': { borderColor: 'gray' },
                            border: '1px solid rgb(128, 128, 128)',
                            borderRadius: '0px',
                            boxShadow: 'none',
                            backgroundColor: '#3E3E3E',
                            cursor: 'pointer'
                          }),
                          valueContainer: base => ({
                            ...base,
                            background: addText.shadowColor,
                            height: '40px'
                          })
                        }}
                      />
                    </DropdownToggle>
                    <DropdownMenu className='shadow-dropdown'>
                      <button
                        type='button'
                        className='defaultLabel'
                        onClick={e => {
                          e.stopPropagation();
                          dispatchers.setShadowColor(e);
                        }}
                      >
                        {string.NO_SHADOW_KEY}
                      </button>
                      <div className='shadow-colors'>
                        {defaultColors.map((color, index) => (
                          <Label check key={color}>
                            <Input
                              type='radio'
                              name='shadowColor'
                              defaultChecked={index === textShadowColorIndex}
                              value={color}
                              onClick={e => {
                                e.stopPropagation();
                                dispatchers.setShadowColor(e);
                              }}
                            />
                            <div
                              className='colorBox'
                              style={{ background: color }}
                            />
                          </Label>
                        ))}
                        <Label check>
                          <Input
                            type='radio'
                            onChange={e => {
                              e.stopPropagation();
                              dispatchers.shadowColorPickerHandler();
                            }}
                          />
                          <div className='colorBox plus-image' />
                        </Label>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>

                  {/* textAlignment */}
                  <ReactSelect
                    id='react-select-font-alignment'
                    isDisabled={!checkForMultilineText(addText.customText)}
                    value={[
                      {
                        value: addText.textAlign,
                        label: this.getTextAlignmentLabel(addText.textAlign)
                      }
                    ]}
                    // value={'textAlign'}
                    options={[
                      { value: 'start', label: string.ALIGN_LEFT_KEY },
                      { value: 'middle', label: string.TEXT_ANCHOR_MIDDLE },
                      { value: 'end', label: string.ALIGN_RIGHT_KEY }
                    ]}
                    onChange={dispatchers.setTextAlign}
                    components={{ IndicatorSeparator }}
                    styles={{
                      control: base => ({
                        ...base,
                        '&:hover': { borderColor: 'gray' },
                        border: '1px solid rgb(128, 128, 128)',
                        borderRadius: '0px',
                        color: '#000',
                        boxShadow: 'none',
                        background: 'none',
                        cursor: 'pointer'
                      }),
                      option: provided => ({
                        ...provided,
                        color: '#000',
                        padding: '5px'
                      }),
                      singleValue: base => ({
                        ...base,
                        color: 'white'
                      })
                    }}
                  />

                  <hr />

                  {/* addText Submit */}
                  <Button
                    className='rounded-0 border-0 add-text'
                    {...(addText.buttonState ? {} : { disabled: true })}
                    size='lg'
                    block
                  >
                    {submitButtonString}
                  </Button>

                  <div className={addText.loaderState}>
                    <img
                      className='mr-2'
                      alt='loader-gif'
                      src={Icons.spinner_small}
                    />
                    {string.PROCESSING_KEY}
                  </div>
                </Form>
              </div>
            </div>

            <div
              className={
                !addText.loaderState ? 'transparent-modal-overlay' : null
              }
            />
          </div>
        </>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    textFonts: state.modal.textFonts,
    inspirationFonts: state.modal.inspirationFonts,
    defaultColors: state.modal.defaultColors,
    addText: state.sideBar.addText,
    documentColors: state.sideBar.documentColors,
    envData: state.modal.envData,
    activeObject: state.fabricCanvas.activeObject,
    language: state.home.language
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators(sideBarActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTextTemplate);
